/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IStackItemStyles, IStackStyles } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';
import { ITextStyles } from '@fluentui/react/lib/Text';
import { CSSProperties } from 'react';
import { FontSizes } from '../../../styles/teams/TeamsType';
import { MOBILE_FONT_SIZE } from '../../../utilities/FontUtils';

export const getMenuEntryCellStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            width: '100%',
            height: '3.5rem',
        },
    };
};

export const getMenuEntryIconContainerStyles = (theme: ITheme): Partial<IStackItemStyles> => {
    return {
        root: {
            display: 'flex',
            width: '3.75rem',
            selectors: {
                svg: {
                    fill: theme.palette.neutralDark,
                },
            },
        },
    };
};

export const getMenuEntryIconStyles = (): CSSProperties => {
    return {
        fontSize: FontSizes.size24,
        width: '1.5rem',
        height: '1.5rem',
        margin: 'auto',
    };
};

export const getMenuTextWrapperStyles = (theme: ITheme): Partial<IStackItemStyles> => {
    return {
        root: {
            borderBottom: `1px ${theme.palette.neutralQuaternaryAlt} solid`,
            boxSizing: 'border-box',
        },
    };
};

export const getMenuEntryTextStyles = (theme: ITheme): Partial<ITextStyles> => {
    return {
        root: {
            fontSize: MOBILE_FONT_SIZE,
            lineHeight: '22px',
            color: theme.palette.neutralDark,
        },
    };
};

export const getMenuEntryRightArrowIconContainerStyles = (): Partial<IStackItemStyles> => {
    return {
        root: {
            display: 'flex',
            width: '2.25em',
        },
    };
};

export const getMenuEntryRightArrowIconStyles = (theme: ITheme): CSSProperties => {
    return {
        fontSize: FontSizes.size10,
        width: '0.625rem',
        height: '0.625rem',
        margin: 'auto',
        color: theme.palette.black,
    };
};
